import { Icon, type INamedIconProps } from '@public/components/Icon/Icon';

export const EarlySigneeIcon = ({ ...props }: INamedIconProps) => (
  <Icon
    height="12"
    iconName="EarlySignee"
    viewBox="0 0 24 24"
    y="25%"
    {...props}
  />
);
